import { db } from "../firebase/firebase";
import { doc, setDoc, increment, serverTimestamp } from "firebase/firestore";

export async function logBlogActivity(type, blogId) {
  const analyticsRef = doc(db, "blogAnalytics", blogId);
  const activityRef = doc(db, "blogAnalyticsActivity", `${blogId}_${Date.now()}`);
  const today = new Date().toISOString().split("T")[0];
  const dailyRef = doc(db, "blogAnalyticsDaily", today);

  // 1. Update all-time totals
  await setDoc(
    analyticsRef,
    {
      views: type === "view" ? increment(1) : increment(0),
      likes: type === "like" ? increment(1) : increment(0),
      lastViewed: type === "view" ? serverTimestamp() : null,
      lastLiked: type === "like" ? serverTimestamp() : null,
    },
    { merge: true }
  );

  // 2. Add activity log
  await setDoc(activityRef, {
    type,
    blogId,
    timestamp: serverTimestamp(),
  });

  // 3. Update daily totals
  await setDoc(
    dailyRef,
    {
      totalViews: type === "view" ? increment(1) : increment(0),
      totalLikes: type === "like" ? increment(1) : increment(0),
      date: today,
    },
    { merge: true }
  );
}
